import {
  AlertCircle,
  ArrowLeft,
  Button,
} from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { DOC_ITEMS } from "./AdminDocumentation";

export const AdminDocumentationViewer: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { docId } = useParams<{ docId: string }>();

  const doc = DOC_ITEMS.find(item => item.id === docId);

  if (!doc) {
    return (
      <div className="page-container">
        <div className="page-section">
          <Button
            variant="ghost"
            className="flex items-center gap-2 mb-4"
            onClick={() => navigate("/admin/user-governance?tab=docs-tools")}
          >
            <ArrowLeft className="w-4 h-4" />
            <span>{t("common.back")}</span>
          </Button>

          <div className="flex items-start gap-3 p-4 border rounded-lg bg-warning-50 border-warning-200">
            <AlertCircle className="w-5 h-5 text-warning-600 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-warning-800">
                {t("common.error")}
              </p>
              <p className="mt-1 text-sm text-warning-700">
                {t("admin.docs.viewer.notFound")}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const fileUrl =
    typeof window !== "undefined" ? `${window.location.origin}${doc.href}` : "";
  const viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
    fileUrl
  )}`;

  return (
    <div className="page-container">
      <div className="page-section">
        <Button
          variant="ghost"
          className="flex items-center gap-2 mb-4"
          onClick={() => navigate("/admin/user-governance?tab=docs-tools")}
        >
          <ArrowLeft className="w-4 h-4" />
          <span>{t("common.back")}</span>
        </Button>

        <h1 className="text-2xl font-semibold text-neutral-900">
          {t(doc.titleKey)}
        </h1>
        <p className="mt-2 text-sm text-neutral-600">{t(doc.descriptionKey)}</p>
      </div>

      <div className="page-section">
        <div className="w-full overflow-hidden border rounded-lg border-neutral-200 bg-neutral-50 aspect-video">
          {fileUrl ? (
            <iframe
              title={t(doc.titleKey)}
              src={viewerUrl}
              className="w-full h-full border-0"
            />
          ) : (
            <div className="flex items-center justify-center h-full text-sm text-neutral-500">
              {t("admin.docs.viewer.loading")}
            </div>
          )}
        </div>
        <p className="mt-2 text-xs text-neutral-500">
          {t("admin.docs.viewer.notice")}
        </p>
      </div>
    </div>
  );
};
